import { NgModule } from '@angular/core';
import { AttendancePipe } from './attendance.pipe';

@NgModule({
    declarations: [
        AttendancePipe,
    ],
    exports: [
        AttendancePipe,
    ]
})
export class AttendancePipeModule { }
